// Action Types
export const actionTypes = {
  SUBMIT_RESERVATION: "SUBMIT_RESERVATION",
  SUBMIT_RESERVATION_SUCCESS: "SUBMIT_RESERVATION_SUCCESS",
  SUBMIT_RESERVATION_FAILED: "SUBMIT_RESERVATION_FAILED",

  RESERVATION_CONFIRMATION: "RESERVATION_CONFIRMATION",
  RESERVATION_CONFIRMATION_SUCCESS: "RESERVATION_CONFIRMATION_SUCCESS",
  RESERVATION_CONFIRMATION_FAILED: "RESERVATION_CONFIRMATION_FAILED",

  //get manage content
  GET_MANAGE_CONTENT: "GET_MANAGE_CONTENT",
  GET_MANAGE_CONTENT_SUCCESS: "GET_MANAGE_CONTENT_SUCCESS",
  GET_MANAGE_CONTENT_FAILED: "GET_MANAGE_CONTENT_FAIELD"
};

// Action creators
export const actionCreators = {
  //get manage content
  getManageContent: params => ({
    type: actionTypes.GET_MANAGE_CONTENT,
    params
  }),
  submitReservation: params => ({
    type: actionTypes.SUBMIT_RESERVATION,
    params
  }),
  paymentConfirmation: params => ({
    type: actionTypes.RESERVATION_CONFIRMATION,
    params
  })
};

// Reducer
const initialState = {
  manageContent: [],
  isGettingManageContent: false,
  data: null,
  meta: null,
  successfulReservation: false,
  paymentConfirmed: 0,
  isLoading: false,
  error: null,
  paymentProgress: 1
};

export default (state = initialState, action) => {
  switch (action.type) {
    //get manage content
    case actionTypes.GET_MANAGE_CONTENT:
      return Object.assign({}, state, {
        error: null,
        isGettingManageContent: true
      });
    case actionTypes.GET_MANAGE_CONTENT_SUCCESS:
      return Object.assign({}, state, {
        error: null,
        isGettingManageContent: false,
        manageContent: action.payload
      });
    case actionTypes.GET_MANAGE_CONTENT_FAILED:
      return Object.assign({}, state, {
        error: action.error,
        isGettingManageContent: false
      });

    case actionTypes.RESERVATION_CONFIRMATION:
    case actionTypes.SUBMIT_RESERVATION:
      return Object.assign({}, state, {
        successfulReservation: false,
        paymentConfirmed: 1,
        paymentProgress: 2,
        data: null,
        isLoading: true,
        error: null
      });

    case actionTypes.SUBMIT_RESERVATION_SUCCESS:
      return Object.assign({}, state, {
        successfulReservation: true,
        paymentProgress: 3,
        isLoading: false,
        error: null,
        data: action.payload
      });

    case actionTypes.RESERVATION_CONFIRMATION_FAILED:
    case actionTypes.SUBMIT_RESERVATION_FAILED:
      return Object.assign({}, state, {
        successfulReservation: false,
        paymentConfirmed: 3,
        paymentProgress: 3,
        isLoading: false,
        data: null,
        error: action.error
      });

    case actionTypes.RESERVATION_CONFIRMATION_SUCCESS:
      console.log(action.payload);
      if (action.payload.error) {
        return Object.assign({}, state, {
          paymentConfirmed: 3,
          paymentProgress: 3,
          isLoading: false,
          error: action.payload.error
        });
      }

      return Object.assign({}, state, {
        paymentConfirmed: 2,
        paymentProgress: 3,
        isLoading: false,
        error: null
      });

    default:
      return state;
  }
};
